import { CreateWarehouseTransferFormState } from "@/models/interface/warehouse-transfer/CreateWarehouseTransferFormState.interface";
import { ReceiveWarehouseTransferFormState } from "@/models/interface/warehouse-transfer/ReceiveWarehouseTransferFormState.interface";
import {
  DetailWarehouseTransfer,
  RequestWarehouseTransfer,
} from "@/models/interface/warehouse.interface";
import moment from "moment";

export class WarehouseTransferMapper {
  static mapRequestWarehouseTransfer(
    state: CreateWarehouseTransferFormState
  ): RequestWarehouseTransfer {
    return {
      attachment: state.attachment || "",
      date: state.date?.format() || "",
      deletedLineIds: state.deletedLineIds || [],
      destinationWarehouseId: state.destinationWarehouse?.key || "",
      notes: state.note || "",
      sourceWarehouseId: state.sourceWarehouse?.key || "",
      transferLines: state.warehouseTransferLines.map(line => ({
        id: line.id,
        productId: line.part?.key || "",
        serialNumber: line.serialNumber?.key || "",
        totalQty: line.totalQty || 0,
        uomId: line.uom?.key || "",
        rackFromId: line.rackFrom?.key || "",
        rackToId: line.rackTo?.key || "",
        notes: line.notes || "",
      })),
    };
  }

  static mapCreateWarehouseTransferFormState(
    detail: DetailWarehouseTransfer
  ): CreateWarehouseTransferFormState {
    return {
      attachment: detail.attachment,
      date: moment(detail.date),
      deletedLineIds: [],
      sourceWarehouse: {
        key: detail.sourceWarehouseId,
        label: detail.sourceWarehouseName,
      },
      note: detail.notes,
      destinationWarehouse: {
        key: detail.destinationWarehouseId,
        label: detail.destinationWarehouseName,
      },
      warehouseTransferLines: detail.transferLines.map(line => ({
        rowId: line.id,

        id: line.id,
        rackFrom: line.rackFromId
          ? { key: line.rackFromId, label: line.rackFromName }
          : undefined,
        rackTo: line.rackToId
          ? { key: line.rackToId, label: line.rackToName }
          : undefined,
        notes: line.notes || "",
        part: {
          key: line.product.id,
          label: line.product.name,
        },
        serialNumber: {
          key: line.serialNumber,
          label: line.serialNumber,
        },
        totalQty: line.qty,
        uom: {
          key: line.uom.id,
          label: line.uom.name,
        },

        loadingPartOptions: false,
        partOptions: [],
        usePartOptions: false,

        uomOptions: [],
        loadingUOMOptions: false,

        serialNumberOptions: [],
        loadingSerialNumberOptions: false,
      })),
      status: detail.state,
    };
  }

  static mapReceiveWarehouseTransferFormState(
    detail: DetailWarehouseTransfer
  ): ReceiveWarehouseTransferFormState {
    return {
      note: detail.notes,
      receivedDate: detail.receivedDate ? moment(detail.receivedDate) : null,
      receiveWarehouseTransferLines: detail.transferLines.map(line => ({
        rowId: line.id,
        id: line.id,
        rackFromName: line.rackFromName,
        rackFromId: line.rackFromId,
        rackToName: line.rackToName,
        rackToId: line.rackToId,
        notes: line.notes,
        part: line.product.name,
        partId: line.product.id,
        serialNumber: line.serialNumber,
        totalQty: line.qty,
        uom: line.uom.name,
        uomId: line.uom.id,
        qtyReceive: line.receivedQty,
        qtyOutstanding: line.outstandingQty,
      })),
    };
  }

  static mapRequestWarehouseTransferFromReceiveForm(
    detail: DetailWarehouseTransfer,
    formState: ReceiveWarehouseTransferFormState
  ): RequestWarehouseTransfer {
    return {
      attachment: detail.attachment,
      date: moment(detail.date).format(),
      deletedLineIds: [],
      destinationWarehouseId: detail.destinationWarehouseId,
      notes: formState.note,
      sourceWarehouseId: detail.sourceWarehouseId,
      receivedDate: formState.receivedDate?.format(),
      transferLines: formState.receiveWarehouseTransferLines.map(line => ({
        id: line.id,
        secureId: line.id,
        productId: line.partId || "",
        serialNumber: line.serialNumber || "",
        totalQty: line.totalQty,
        uomId: line.uomId || "",
        receivedQty: line.qtyReceive,
        rackFromId: line.rackFromId || "",
        rackToId: line.rackToId || "",
        notes: line.notes || "",
      })),
    };
  }
}
